import * as log from 'loglevel';
import {forEach, times, random, concat, pull, sample, find, head, get} from 'lodash';
import {game} from "../../GameCore";
import {gameConfig} from "../../config/GameConfig";
import {levelGroup} from "../Level";
import {IPlatform} from 'power-patrol';
import {IPlatformTile} from 'power-patrol';
import {getGameManager} from '../../GameManager';
import {gameState} from "../../config/GameState";
import {getTileSetId} from '../backgrounds/Backgrounds';
import {playerSprite, playerAnimSprite} from '../../sprites/player/Player';


export var obstacles: Phaser.Sprite[];
export var obstacleSprites: Phaser.Sprite[];

var timer: Phaser.Timer;



/**
 * create a pool of platform sprites we can re-use
 */
export function createObstacles()
{
    var sprite: Phaser.Sprite,
        warningSprite: Phaser.Sprite;

    //  create a group to hold platform sprites

    //platformGroup = levelGroup.addChild(game.add.group())

    obstacles = obstacles || [];

    obstacleSprites = times(5, (i: number) =>
    {
        //  create a sprite

        sprite = game.add.sprite(-500, -500, 'obstacles');

        //  enable physics on the sprite

        game.physics.arcade.enable(sprite);

        //  set sprite physics properties

        sprite.body.allowGravity = false;
        sprite.body.customSeparateX = true;
        sprite.body.customSeparateY = true;
        sprite.alive = false;

        //  add the sprite to the level group

        levelGroup.addChild(sprite);

        //  add a warning sign sprite to each obstacle

        warningSprite = game.add.sprite(0, 0, 'sprites', 'trip-hazard');

        sprite.addChildAt(warningSprite, 0);

        //  save the warning sign sprite

        (<any>sprite).warningSprite = warningSprite;

        var tweenA: Phaser.Tween,
            tweenB: Phaser.Tween;

        tweenA = game.add.tween(warningSprite).to( { y: -70 }, 500, Phaser.Easing.Exponential.In);
        tweenB = game.add.tween(warningSprite).to( { y: -80 }, 500, Phaser.Easing.Exponential.Out);

        tweenA.chain(tweenB);

        tweenB.onComplete.add(() =>
        {
            tweenA.start();
        }, this);

        (<any>warningSprite).tweens = [tweenA, tweenB];

        //  return the sprite

        return sprite;
    });
}


/**
 * reset and remove all powerups
 */
export function resetObstacles()
{
    //  stop the current timer

    if (timer) timer.stop();

    //  reset positions for all power ups

    forEach(obstacleSprites, (sprite: Phaser.Sprite) =>
    {
        sprite.kill();
    });
}

export function restartObstacles()
{
    //  restart power up timer

    timer = game.time.create(false);

    //  queue a power up

    //queueObstacle();

    //  start the timer

    timer.start();
}


/**
 * init and place a power up in the level
 */
export function queueObstacle()
{
    //var nextPowerUpDuration: number;

    //  don't create platforms when we're outside

    if (gameState.level.isOutside) return;

    //  add a power up to the game

    //addObstacle();

    //  restart the timer for the next power-up

    //nextPowerUpDuration = 2000 + Math.random() * 3000;
    //
    //timer.add(nextPowerUpDuration, queueObstacle);
}


/**
 * add a new power up to the stage
 */
export function addObstacle(x: number)
{
    var sprite: Phaser.Sprite,
        frameName: string,
        signSprite: Phaser.Sprite,
        y: number;

    //  get the first available power-up sprite

    sprite = findFirstDead();

    //  if no sprite is available, stop here

    if ( ! sprite) return;

    //  reset and place the sprite

    frameName = sprite.frameName = getRandomObstacleFrame();

    var frame: Phaser.Frame = game.cache.getFrameData("obstacles").getFrameByName(frameName);

    //  get sign sprite

    signSprite = (<any>sprite).warningSprite;

    signSprite.x = frame.width * 0.5;
    signSprite.y = -80;
    signSprite.anchor = new Phaser.Point(0.5, 0);
    signSprite.scale.setTo(0.75, 0.75);

    //  play bounce animation for the warning sign

    (<Phaser.Tween>get(signSprite, 'tweens[0]')).start();

    //  calculate sprite y position based on the obstacle's height

    y = game.world.height - gameConfig.tileWidth - sprite.height;

    sprite.reset(x, y);


    sprite.body.setSize(frame.width * 0.5, frame.height * 0.5, frame.width * 0.25, frame.height * 0.5);
}



/**
 * get a random obstacle for the current stage
 */
function getRandomObstacleFrame() : string
{
    return <string>sample(gameConfig.level.obstacles[getTileSetId()]);
}


/**
 * find the first dead power-up sprite to re-use
 */
function findFirstDead()
{
    return find(obstacleSprites, { alive: false });
}



/**
 * collect a power up and activate its power
 * @param sprite
 */
export function hitObstacle(sprite: Phaser.Sprite)
{
    //  kill the sprite

    sprite.kill();

    //  play bump animation

    playerAnimSprite.animations.play('stumble');

    //  kill the sign bounce tweens

    killSignTweens(sprite);

    //  modify score

    getGameManager().incrementScore(-500);

    //  display power-up effect to the user

    getGameManager().visibleBonus('-500 points');
}



/**
 * get the y position for a platform with a given index
 * @param level
 */
function getObstacleY(level: number) : number
{
    //  return the new platform y position

    return game.world.height - gameConfig.tileWidth * 2;
}


/**
 * check whether the first power-up has scrolled off the page
 */
export function updateObstacles()
{
    //  get the first tile in the list

    //sprite = head(powerUpSprites);

    forEach(obstacleSprites, (sprite: Phaser.Sprite, i: number) =>
    {
        //  if the sprite is still in play stop here

        if (sprite.body.x > gameConfig.tileWidth * -3 || sprite.body.y < 0) return;

        log.warn('removing obstacle sprite');

        //  if it's scrolled off the screen, remove it from play

        sprite.reset(0, -400);
        sprite.kill();

        //  kill the sign bounce tweens

        killSignTweens(sprite);
    })
}


/**
 * stop the sign bouncing when it leaves the stage
 * @param sprite
 */
function killSignTweens(sprite: Phaser.Sprite)
{

    forEach(get(sprite, 'signSprite.tweens'), (tween: Phaser.Tween) =>
    {
        tween.stop();
    });
}


// WEBPACK FOOTER //
// ./src/ts/game/level/ground/Obstacles.ts